import React, { FormEvent, FunctionComponent, useCallback } from 'react';
import styled from 'styled-components';

import { SubmitButton } from 'components';
import { Button, Heading } from 'components/chroma';

import {
  MotorFullPageProps,
  VehicleFromSearch,
  VehicleSearchType,
} from 'scenes/motor/types';
import {
  getVehicleFromSearch,
  hasVehicleFromSearchData,
} from 'scenes/motor/selectors';

import VehicleDetailCard, { VehicleDetail } from './VehicleDetailCard';

const ManualSelectionButtonWrapper = styled.div`
  text-align: center;
`;

const VehicleDetailWrapper = styled.div`
  margin: 0px 0px 1.5rem;
`;

const toVehicleDetail = (vehicle: VehicleFromSearch): VehicleDetail => ({
  name: `${vehicle.year} ${vehicle.make} ${vehicle.family}`,
  model: `${vehicle.variant} ${vehicle.driveType} ${vehicle.engine.description}`,
  transmission: vehicle.transmissionType,
  registration: vehicle.plateNumber,
});

export const VehicleDetailConfirmationStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
  onPrevious,
}) => {
  const onSubmit = useCallback(
    (event: FormEvent) => {
      onNext({});
      event.preventDefault();
    },
    [onNext]
  );

  const goToVehicleManualSelect = useCallback(() => {
    onNext({
      vehicleSearchType: VehicleSearchType.ManualEntry,
    });
  }, [onNext]);

  const vehicle = getVehicleFromSearch(funnelState);

  return (
    <form onSubmit={onSubmit}>
      <Heading size={3}>Is this the car?</Heading>
      <VehicleDetailWrapper>
        <VehicleDetailCard
          vehicleDetails={toVehicleDetail(vehicle)}
          onPrevious={onPrevious}
        />
      </VehicleDetailWrapper>
      <SubmitButton enabled={hasVehicleFromSearchData(funnelState)}>
        Yes this is the car
      </SubmitButton>
      <ManualSelectionButtonWrapper>
        <Button
          secondary
          maxWidth
          center="true"
          margin={{ top: 3 }}
          onClick={goToVehicleManualSelect}
        >
          Select the car manually
        </Button>
      </ManualSelectionButtonWrapper>
    </form>
  );
};

export default VehicleDetailConfirmationStep;
